module.exports = __webpack_public_path__ + "static/media/gt.ac025893.png";